/**
 * T9 A33 — chọn múi giờ tenant (thuần, test được): ưu tiên `timeZone` của `/iam/me/permissions` (mọi người dùng), rồi hồ sơ tenant (`/tenant/me`, cần
 * `admin.tenant.overview`), còn lại undefined (mặc định Asia/Ho_Chi_Minh). Chế độ platform → undefined.
 */
export function pickTenantTimeZone(
  mode: string,
  fromPermissions: string | null | undefined,
  fromProfile: string | null | undefined,
): string | undefined {
  if (mode !== 'tenant') return undefined;
  const valid = (z: string | null | undefined) => (z?.trim() ? z.trim() : undefined);
  return valid(fromPermissions) ?? valid(fromProfile);
}
